export function transformMoney (money, currency) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || "EUR"}).format(money)
}

/**
 * Rundet einen Geldbetrag sauber auf 2 Nachkommastellen.
 * Rechnet in Cent, um Floating-Point-Fehler (z.B. 100 * 0.19 = 19.000000000000004)
 * zu vermeiden. Gibt immer eine Number zurück (nie einen String wie .toFixed()).
 */
export function roundMoney (value) {
    const num = Number(value);
    if (!Number.isFinite(num)) return 0;
    // EPSILON-Korrektur gegen Fälle wie 1.005 -> 1.00 statt 1.01
    return Math.round((num + Number.EPSILON) * 100) / 100;
}

/**
 * Wandelt eine Eingabe (String aus einem Input, Number, null, "") in eine
 * gültige Geld-Number um. Akzeptiert sowohl Komma als auch Punkt als Dezimaltrenner.
 * Ungültige/leere Eingaben werden zu 0.
 */
export function parseMoney (value) {
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;
    if (value == null) return 0;
    const num = Number(String(value).trim().replace(",", "."));
    return Number.isFinite(num) ? num : 0;
}
